import Pagination from "@/components/share/pagination";
import Service from "./../../../utils/api/service";
import Helper from "./../../../utils/global/func";
import TableLoading from "./../../../components/share/table-loading";
import NoItem from "./../../../components/share/table-no-item";
import { mapState } from "vuex";

export default {
  name: "ListShowroom",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      fields: {
        id: "",
        index: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      },
      data: {
        showroom: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
  },
  created() {
    this.getAllShowroom();
  },
  watch: {
    "$route.fullPath": function () {
      this.getAllShowroom();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getAllShowroom() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        ...query,
      });
      let params = this.$helper.queryParam(setQuery);

      Service.getAllShowroom(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getAllShowroom();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.showroom = [];
            this.$toasted.show(response?.message);
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          if (response?.data.length > 0) {
            this.isNoData = false;
            this.data.showroom = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
          } else {
            this.data.showroom = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    popupModal(index) {
      this.fields.index = index;
      this.display.modal.delete.show = true;
    },

    deleteShowroom() {
      this.isDeleting = true;
      let advertisementId = this.data.showroom[this.fields.index].id;
      Service.deleteShowroom(advertisementId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteShowroom();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.showroom.splice(this.fields.index, 1);
          this.data.pagination.total -= 1;
          this.$toasted.show("Showroom has been deleted.");
          this.closeModal();
        }
      });
    },

    imagePreview(index) {
      if (this.data.showroom[index].thumbnailUrl) {
        this.display.modal.imagePreview.index = index;
        this.display.modal.imagePreview.show = true;
      }
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      };
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },
  },
};
